import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from "../../GlobalFiles/Sidebar";
import { FaPlusCircle, FaPlusSquare, FaTablets, FaTrash } from 'react-icons/fa';
import { useEffect } from 'react';
import { API_BASE_URL } from "../../../../../api";
import { Input, Modal, Table } from 'antd';
import { toast } from 'react-toastify';

const TestRelated = () => {
  const { data: { user } } = useSelector((state) => state.auth);
  const isManager = user?.userType === 'admin';
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const [textInfos, setTextInfos] = React.useState([]);
  const [infoType, setInfoType] = React.useState('testValue');
  const [value, setValue] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [initialLoading, setInitialLoading] = React.useState(true);
  const [currentModal, setCurrentModal] = React.useState(null); // 'view', 'create', 'edit'
  const [searchText, setSearchText] = React.useState('');

  useEffect(() => {
    const fetchTextInfos = async () => {
      setInitialLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/textInfo`);
        const data = await response.json();
        setTextInfos(data);
      } catch (error) {
        console.error('Error fetching text infos:', error);
      } finally {
        setInitialLoading(false);
      }
    };
    fetchTextInfos();
  }, []);


  const handleCreateTextValue = async () => {
    setIsLoading(true);
    try {
      const newInfo = { infoType, value };
      // console.log('Creating text info:', newInfo);
      const res = await fetch(`${API_BASE_URL}/textInfo/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newInfo),
      });
      const createdInfo = await res.json();
      setTextInfos([...textInfos, newInfo]);
      toast.success('Text info created successfully');
      setValue('');
    } catch (error) {
      console.error('Error creating text info:', error);
      toast.error('Failed to create text info');
    } finally {
      setIsLoading(false);
    }
  };


  const handleDeleteTextValue = async (id) => {
    setIsLoading(true);
    try {
      await fetch(`${API_BASE_URL}/textInfo/${id}`, {
        method: 'DELETE',
      });
      setTextInfos(textInfos.filter(info => info._id !== id));
      toast.success('Text info deleted successfully');
    } catch (error) {
      console.error('Error deleting text info:', error);
      toast.error('Failed to delete text info');
    } finally {
      setIsLoading(false);
    }
  };



  const filteredTextInfos = textInfos.filter(
    (info) =>
      info.infoType === infoType &&
      info.value.toLowerCase().includes(searchText.toLowerCase())
  );

  if (!isManager) {
    return (
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <div className="flex-1 p-4 md:p-8 flex items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
            <p className="text-gray-600">Only managers can access this page.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex min-h-screen bg-gray-50">
        <Sidebar onCollapse={setSidebarCollapsed} />
        <div className={`flex-1 p-6 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0'}`}>

          <div className="p-6 ml-40">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-3 gap-4 bg-gradient-to-r from-sky-600 to-indigo-500 p-6 rounded-lg">
              <h1 className="text-3xl font-bold text-gray-200 flex items-center">
                <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Test Management
              </h1>
            </div>

            <div className="grid grid-cols-3 sm:grid-cols-3 gap-4">
              <Link to="/test-management" className="block">
                <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                  <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </div>
                  <h3 className="text-sm font-medium text-gray-900">Test  Management</h3>
                </div>
              </Link>

              {initialLoading ? (
                <div className="col-span-3 text-center py-10">
                  <p>Loading...</p>
                </div>
              ) : (
                <>
                  <button
                    onClick={() => {
                      setInfoType('testValue');
                      setCurrentModal('view');
                    }}
                    className="block">
                    <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                      <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-green-400 to-blue-600">
                        <FaTablets className="w-4 h-4" />
                      </div>
                      <h3 className="text-sm font-medium text-gray-900">Test Values</h3>
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      setInfoType('testUnit');
                      setCurrentModal('view');
                    }}
                    className="block">
                    <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                      <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-green-400 to-blue-600">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M4 4h16v16H4z" />
                          <path d="M4 10h16" />
                          <path d="M10 4v6" />
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-900">Test Units</h3>
                    </div>
                  </button>


                  <button
                    onClick={() => {
                      setInfoType('testValue');
                      setCurrentModal('create');
                    }}
                    className="block">
                    <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                      <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-green-400 to-blue-600">
                        <FaPlusSquare className="w-4 h-4" />
                      </div>
                      <h3 className="text-sm font-medium text-gray-900">Add Test Values</h3>
                    </div>
                  </button>

                  <button
                    onClick={() => {
                      setInfoType('testUnit');
                      setCurrentModal('create');
                    }}
                    className="block">
                    <div className="flex flex-col items-center justify-center gap-2 p-3 bg-white rounded-lg shadow hover:shadow-md transition h-24 text-center">
                      <div className="w-10 h-10 rounded-md flex items-center justify-center text-white bg-gradient-to-br from-green-400 to-blue-600">
                        <FaPlusCircle className="w-4 h-4" />
                      </div>
                      <h3 className="text-sm font-medium text-gray-900">Add Test Units</h3>
                    </div>
                  </button>
                </>)
              }
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={<div className='flex justify-between items-center mr-6'>
          <h1>Test {infoType === "testValue" ? "Value" : "Unit"}</h1>
          <Input
            placeholder="Search..."
            className="ml-4 w-1/3"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>}
        open={currentModal === 'view'}
        onCancel={() => setCurrentModal(null)}
        onDismiss={() => { setCurrentModal(null); }}
        footer={null}
      >
        <div>
          {textInfos.length === 0 ? (
            <p>No test values found.</p>
          ) : (
            <Table
              showHeader={false}
              rowClassName={(_, index) =>
                index % 2 === 0 ? "bg-gray-200" : "bg-green-50"
              }
              className="w-full text-center"
              dataSource={filteredTextInfos.map((info) => ({ ...info, key: info._id }))}
              columns={[
                {
                  title: 'Value',
                  dataIndex: 'value',
                  key: 'value',
                },
                {
                  title: '',
                  key: 'actions',
                  className: 'text-right',
                  render: (_, record) => (
                    <button
                      onClick={() => handleDeleteTextValue(record._id)}
                      className="text-white font-bold py-1 px-2 rounded text-center hover:bg-gray-300"
                    >
                      <FaTrash className='h-4 w-4 text-red-900' />
                    </button>
                  ),
                },
              ]}
            />
          )}
        </div>
      </Modal>

      <Modal
        title={`Add Test ${infoType === "testValue" ? "Value" : "Unit"}`}
        open={currentModal === 'create'}
        onCancel={() => setCurrentModal(null)}
        onDismiss={() => { setCurrentModal(null); }}
        footer={null}
      >
        <div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleCreateTextValue();
            }}
          >
            <div className="mb-4">
              <Input
                type="text"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                required
              />
            </div>
            <div className="flex items-center justify-end">
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Create Test {infoType === "testValue" ? "Value" : "Unit"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default TestRelated;